import React, { FC } from "react";

export const BrandPlus: FC<JSX.IntrinsicAttributes> = (props) => {
  return (
    <svg viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.5 7.3125V11.6875H10.9375V18.25H6.5625V11.6875H0V7.3125H6.5625V0.75H10.9375V7.3125H17.5Z"
        fill="#FF478F"
      />
      <path
        d="m6.5625 0.75165h4.375v6.5625l-4.375 4.3762-6.5625-0.0013-1.9129e-7 -4.375h6.5625v-6.5625z"
        fill="#FF9800"
      />
    </svg>
  );
};
